export { PatientLinkTable } from './linked-link-table';
export { PatientLinkReceivedTable } from './received-link-table';
export { PatientLinkSentTable } from './sent-link-table';
